import React from "react";
import Header from "./components/Header";
import HomeHero from "./components/home/HomeHero";
import IPEFSearch from "./components/IPEFSearch"; // Import the IPEFSearch component
import { Routes, Route } from "react-router-dom";
import "./App.css";
import Footer from "./components/Footer";
import AboutUs from "./components/AboutUs";
import Testimonials from "./components/Testimonials";
import IEPFClaim from "./components/services/IEPFClaim";
import ROC from "./components/services/ROC";
import DuplicateShares from "./components/services/DuplicateShares";
import TransmissionShares from "./components/services/TransmissionShares";
import UnclaimedMF from "./components/services/UnclaimedMF";
import UnclaimedPF from "./components/services/UnclaimedPF";
import Associate from "./components/Associate";
import PrivacyPolicy from "components/PrivacyPolicy";
import TermsConditions from "components/TermsConditions";


const App: React.FC = () => {
  return (
    <div>
      <Header /> {/* Header remains on all pages */}
      <Routes>
        <Route path="/" element={<HomeHero />} /> {/* Route for HomeHero */}
        <Route path="/ipef-search" element={<IPEFSearch />} /> {/* Route for IPEFSearch */}
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/iepf_claim" element={<IEPFClaim />} />
        <Route path="/roc_services" element={<ROC/>} />
        <Route path="/duplicate_shares" element={<DuplicateShares/>} />
        <Route path="/transmission_shares" element={<TransmissionShares />} />
        <Route path="/unclaimed_mutual_fund" element={<UnclaimedMF />} />
        <Route path="/unclaimed_provident_fund" element={<UnclaimedPF />} />
        <Route path="/become-associate" element={<Associate />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer /> 
    </div>
  );
};

export default App;